import { LazyLoad } from 'app/utils';

export const SurveyListPage = LazyLoad(
  () => import('./index'),
  (module) => module.SurveyListPage,
);
